export const checkCookieExist = (name: string) => {
  // Find the cookie
  const match = document.cookie.match(
    RegExp('(?:^|;\\s*)' + name + '=([^;]*)')
  );
  return match ? true : false;
};

export const deleteCookie = (name: string) => {
  document.cookie = name + '=; Expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
};

/**
 * Candidate cookie domains for `host`, most specific first, stopping at the
 * registrable apex so we never emit a public suffix such as `.com`:
 *
 *   www.netspend.com -> ['.www.netspend.com', '.netspend.com']
 *
 * Returns an empty list for localhost and raw IP hosts, where domain-scoped
 * cookies cannot be shared and a host-only cookie is the only option.
 */
const getCookieDomains = (host: string = location.hostname): string[] => {
  const hostname = host.split(':')[0].toLowerCase();
  if (
    hostname.includes('localhost') ||
    /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)
  ) {
    return [];
  }
  const labels = hostname.split('.').filter(Boolean);
  if (labels.length < 2) {
    return [];
  }
  // Drop the last label so the shortest candidate is the registrable apex.
  return labels
    .slice(0, labels.length - 1)
    .map((_label, index) => `.${labels.slice(index).join('.')}`);
};

/**
 * Expire `name` for the current host *and* for every parent domain up to the
 * registrable apex.
 *
 * JavaScript cannot read a cookie's Domain attribute, so a host-only expiry
 * (see `deleteCookie`) silently no-ops against a cookie that was written with
 * `Domain=.netspend.com` by another sub-domain. Issuing the expiry once per
 * candidate domain is the only reliable way to remove a cookie whose scope we
 * do not control.
 */
export const deleteCookieAcrossSubdomains = (
  name: string,
  host: string = location.hostname
) => {
  const expiry = `${name}=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
  // Host-only cookie for the current host.
  document.cookie = expiry;
  getCookieDomains(host).forEach((domain) => {
    document.cookie = `${expiry};domain=${domain}`;
  });
};

export const ACP_Next_Cookie = 'ACP_Next';
